import { faExternalLink } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { AppRole } from "../../../@api";

import { FeatureCard } from "../../components/Pages";
import { translationKeys } from "../../models/app-translation-keys";
import { Features } from "../feature.enum";
import { IFeature } from "../iFeature";

export const schornBoxFeature: IFeature = {
  id: Features.SchornBox,
  menuItem: {
    label: translationKeys.feature.schornbox.link,
    breadCrumbTitle: translationKeys.feature.schornbox.breadCrumbTitle,
    externalUrl: `https://www.schorn.ai/`,
    showFooter: true,
    icon: () => <FontAwesomeIcon icon={faExternalLink} />,
  },
  card: (
    <FeatureCard
      featureKey={Features.SchornBox}
      featureIcon={faExternalLink}
      buttonIcon={faExternalLink}
      externalUrl="https://www.schorn.ai/"
    />
  ),
  role: AppRole.SchornBoxFeature,
};
